export default {
  meau: {
    nav1: 'Trang chủ',
    nav2: 'Cộng đồng',
    nav3: 'Tải xuống',
    nav4: 'Phần thưởng',
    nav5: 'NFT'
  },
  cont1: {
    text1: 'Phần mềm điều khiển từ xa dựa trên nền tảng blockchain',
    text2: 'Kết nối đa màn hình để làm việc và giải trí mọi lúc mọi nơi',
    btn: 'Tải ngay',
    text3_1: 'Tham gia',
    text3_2: 'cộng đồng',
    text3_3: 'để nhận thưởng DeepLink Coin!'
  },
  cont2: {
    text1: 'DeepLink',
    text2: 'Dựa trên các khả năng của công nghệ giảm độ trễ chơi game để đưa mọi thiết bị vào trong tầm tay',
    text3: 'Năng lực cốt lõi và thế mạnh kỹ thuật',
    text4: 'Dựa trên các khả năng cốt lõi của chơi game trên đám mây, trải nghiệm vượt trội hơn nhiều so với điều khiển từ xa truyền thống!',
    leaf1: {
      text1: 'Độ mượt cao, hiệu năng cao',
      text2: 'Chi phí thấp',
      text3: 'Giải pháp mã hóa dẫn đầu ngành giúp tiêu thụ tài nguyên tối thiểu với cùng lưu lượng mã ',
      text4: 'Mạng ngang hàng P2P: Hỗ trợ ipv6 với thông lượng NAT lên tới 95% mà không tốn dung lượng băng thông.'
    },
    leaf2: {
      text1: 'Tốc độ khung hình cao, độ trễ thấp',
      text2: '',
      text3: "Với độ trễ LAN <15 mili giây và khả năng hiển thị 4K 240Hz, WAN cũng được đánh giá thuộc hàng đầu thế giới."
    },
    leaf3: {
      text1: 'Độ nét cao',
      text2: '',
      text3: 'Các thuật toán thông minh làm tăng chất lượng hình ảnh ở cùng tốc độ bit và tái tạo màu sắc chân thực nhất.'
    },
    leaf4: {
      text1: 'Độ ổn định cao',
      text2: '',
      text3: 'Các chiến lược chống mất gói tin và chống tắc nghẽn được hỗ trợ bởi lượng lớn dữ liệu, cho phép nhanh chóng điều chỉnh tình trạng mất gói tin và tắc nghẽn dữ liệu.'
    },
    leaf5: {
      text1: 'Độ bảo mật cao',
      text2: '',
      text3: 'Tất cả dữ liệu được mã hóa bởi DTLS1.2 với AES256.'
    }
  },
  cont3: {
    text1: "Mượt như đang điều khiển thiết bị tại chỗ",
    text2: 'Áp dụng hàng chục kỹ thuật tối ưu hóa trong ba lĩnh vực chính, DeepLink có thể duy trì tốc độ khung hình cao dù cho có tỷ lệ mất gói tin 5% và độ trễ mạng 100 mili giây*. Đáp ứng yêu cầu trong mọi thể loại môi trường mạng.',
    li1: {
      text1: 'Công nghệ đối phó với mạng yếu',
      text2: 'Chiến lược chống mất gói tin FEC',
      text3: 'Dự báo băng thông',
      text4: 'Chiến lược mã hóa SVC'
    },
    li2: {
      text1: 'Kỹ thuật tối ưu hóa đường truyền',
      text2: 'Dự đoán cổng vân tay',
      text3: 'Hỗ trợ IPV6',
      text4: 'UPNP',
      text5: 'Định tuyến thông minh'
    },
    li3: {
      text1: 'Công nghệ xử lý hiển thị',
      text2: 'Chiến lược thích ứng tốc độ khung hình',
      text3: 'Dự đoán hình ảnh chuyển động',
      text4: 'Chiến lược xử lý biến thiên độ trễ',
      text5: 'Kết xuất hình ảnh HD nền tảng AI mã thấp',
      text6: 'Ứng dụng thực tế ảo động'
    },
    desc3: 'LAN < 5 mili giây - Mạng liên thành < 10 mili giây - Mạng liên tỉnh < 30 mili giây'
  },
  cont4: {
    text1: 'Chất lượng đồ họa siêu rõ nét',
    text2: 'Độ phân giải Ultra HD',
    text3: 'Hỗ trợ 1,07 tỷ màu',
    text4: '4:4:4 chất lượng hình ảnh không bị hư hại',
    text5: "DeepLink luôn sử dụng các chỉ số chất lượng hình ảnh khắt khe hơn để đạt được trải nghiệm hình ảnh vượt xa các công nghệ điều khiển từ xa truyền thống khác, với độ méo hình ảnh từ xa nằm dưới giới hạn nhận dạng của mắt người, hỗ trợ trọn vẹn cho nhu cầu hiển thị hình ảnh chính xác trong ngành công nghiệp sáng tạo.",
    text6: '*PSNR đề cập đến Tỷ lệ tín hiệu cực đại trên nhiễu, dưới 20dB độ méo hình ảnh cao, 20-30dB độ méo hình ảnh ở mức trung bình, 30-40dB độ méo hình ảnh thấp, trên 40dB độ méo hình ảnh cực kỳ thấp và không thể phát hiện bằng mắt thường.'
  },
  cont5: {
    text1: 'Hỗ trợ ngoại vi rộng rãi',
    text2: 'DeepLink cung cấp hỗ trợ từ xa cho các công cụ chuyên dụng trong ngành công nghiệp sáng tạo như bảng kỹ thuật số và cần điều khiển, đồng thời tối ưu hóa việc sử dụng phần mềm sáng tạo như PS, Zbrush và Unity để đảm bảo trải nghiệm nhất quán các công cụ sản xuất sáng tạo bất kể khi dùng từ xa hay tại chỗ.'
  },
  cont6: {
    text1: 'Bảo mật đa tầng - Tiếp cận đơn giản',
    block1: {
      title1: 'Tài khoản an toàn',
      desc1: 'Cơ chế bảo vệ tài khoản nhiều lớp đảm bảo yên tâm',
      title2: 'Kết nối an toàn',
      desc2: 'Giao thức bảo mật DTLS1.2, chỉ truy cập khi được ủy quyền',
      title3: 'Dữ liệu an toàn',
      desc3: 'Mã hóa AES 256-bit, an toàn trong suốt quá trình truyền dữ liệu',
      title4: 'Thiết bị an toàn',
      desc4: 'Chỉ người tương ứng mới nhìn thấy thiết bị tương ứng theo cài đặt của bạn'
    },
    block2: {
      title1: 'Bảo mật đa tầng',
      desc1: 'Bảo mật mọi kết nối',
      title2: 'Dễ sử dụng',
      desc2: 'Dễ bắt đầu'
    },
    block3: {
      title1: 'Tải xuống nhẹ',
      desc1: "Phần mềm DeepLink chỉ nặng khoảng 10M đối với bản người dùng cuối cùng",
      title2: 'Dễ học',
      desc2: 'Cài đặt theo hướng dẫn',
      title3: 'Dễ sử dụng',
      desc3: 'Điều khiển từ xa bất kỳ thiết bị thông qua chuột'
    }
  },
  cont7: {
    text1: 'Tâm huyết trong việc cung cấp các giải pháp điều khiển từ xa',
    block1: {
      word1: 'Ngành giáo dục',
      word2: 'Ngành công nghiệp trò chơi',
      word3: 'Ngành sáng tạo & thiết kế',
      word4: 'Ngành công nghệ thông tin',
      word5: 'Nhiều nhà kinh doanh đang được khai sinh',
      word6: 'Nhiều đối tác trên khắp thế giới',
      word7: 'Dịch vụ Vận hành và Bảo trì từ xa IT O&M',
      word8: 'Người dùng cá nhân và game thủ'
    },
    block2: {
      text1: 'Hỗ trợ các tình huống điều khiển từ xa trong nhiều ngành khác nhau',
      text2: 'Dựa trên nhu cầu thực tế của doanh nghiệp trong các ngành khác nhau, chúng tôi giúp họ đạt được mục tiêu kinh doanh theo cách tiết kiệm năng lượng.',
      text3: 'Cung cấp các chính sách cá nhân hóa và mã hóa, linh hoạt, bảo mật',
      text4: "Nhân viên công ty có thể dựa trên phân quyền truy cập tài nguyên của công ty mọi lúc mọi nơi."
    },
    block3: {
      text1: 'Đáp ứng nhu cầu đa dạng của người dùng',
      text2: 'Cho dù bạn chọn sử dụng cho nhân viên nội bộ,',
      text3: 'hay cho khách hàng, đối tác bên ngoài hoặc thậm chí dùng cho cá nhân.',
      text4: 'Ứng dụng điều khiển từ xa của chúng tôi có thể phục vụ bạn trên các thiết bị và nền tảng chính,',
      text5: 'đưa ra một phương thức thay thế có thể giải quyết vấn đề một cách đơn giản và thông minh.'
    }
  },
  footer: {
    link: 'Đường dẫn',
    community: 'Hãy theo dõi cộng đồng của chúng tôi',
    tip: 'Cộng đồng của chúng tôi trên: Twitter, telegram, reddit, medium, discord, tiktok, YouTube'
  },
  reward: {
    title1: 'DeepLink node',
    desc1: 'Có quyền truy cập vào các phần thưởng, ví dụ: DeepLink Token, Crown NFT, và quyền hội đồng quản trị.',
    title2: 'Nhận Genesis Node NFT',
    text1: "Càng nhiều người dùng trong mạng lưới DeepLink thì càng cần nhiều phép tính và lưu lượng truy cập. Các Genesis Node cung cấp cơ sở hạ tầng cho mạng lưới DeepLink, nhờ đó phi tập trung hóa và giúp DeepLink phát triển nhanh hơn.",
    text2: 'Bằng cách mua một Genesis Node NFT, bạn có cơ hội nhận phần thưởng cho đóng góp của mình vào mạng lưới.',
    text3: 'Đó có thể bao gồm DeepLink Token, Crown NFT, và quyền hội đồng quản trị.',
    text4_1: 'Bạn có câu hỏi? Hãy tương tác với chúng tôi trên',
    text4_2: 'và',
    text4_3: '',
    btntext: 'Mua ngay',
    text5: 'Cứ 1000 Genesis Node NFT được bán, giá sẽ tăng thêm 1000USD',
    text6_1: 'Số lượng node',
    text6_2: 'mỗi NFT hiện hỗ trợ',
    text7: 'Tổng số Genesis Node NFT',
    text8: 'Phát hành vĩnh viễn',
    text9: 'Giá ban đầu',
    text10_1: 'Số lượng node tối đa',
    text10_2: 'Được hỗ trợ trên mỗi NFT',
    text11: 'Giá tối đa',
    text12: 'Genesis node là gì?',
    text13: 'Genesis node đảm nhận nhiệm vụ cốt lõi trong việc tính toán và chuyển tiếp lưu lượng truy cập của mạng lưới DeepLink, đồng thời DeepLink cho phép nhiều người tham gia hơn để đạt được doanh thu thông qua mô hình khai thác.',
    text14: 'Tổng cộng có bao nhiêu Token đã được đưa vào các Genesis node để thưởng?',
    text15: '30% tổng số Token, tức là 30 tỷ DeepLink Token',
    text16: 'Genesis Node NFT là gì?',
    text17: 'Chỉ những người sở hữu Genesis Node NFT mới được phép tham gia khai thác.',
    text18: 'Doanh thu từ việc bán Genesis Node NFT được phân phối như thế nào?',
    text19: '50% số tiền thu được sẽ được đầu tư vào pool phần thưởng thanh khoản phi tập trung (ví dụ: DeepLink Token/USDC cho Uniswap, Sushiswap) và 50% số tiền thu được sẽ được đưa về công ty điều hành DeepLink.',
    text20: 'Cơ chế khai thác cụ thể là gì?',
    text21: 'Tổng phần thưởng là 5 tỷ một năm, cứ mỗi 3 năm thì giảm một nửa, 10% doanh thu DeepLink Crown NFT được dùng để mua lại DeepLink Token và thêm vào tổng phần thưởng trước mỗi đợt giảm một nửa, là một phần của 50% phần thưởng Token, được thưởng đến tất cả node trong 3 năm. Ví dụ: sau 3 năm, 10% thu nhập của DeepLink Crown NFT có thể mua lại 12 tỷ DeepLink Token, thì tổng phần thưởng còn lại là: 12 tỷ + 15 tỷ, tổng cộng là 27 tỷ, và tổng phần thưởng hàng năm từ đợt 3-năm lần thứ hai là 27 tỷ * 50% * 1/3 = 4,5 tỷ.',
    text22: 'Các yêu cầu đối với máy Genesis node là gì?',
    text23: "Mỗi máy phải đã nằm trong mạng lưới DeepBrain Chain. DeepBrain Chain là mạng máy tính hiệu suất cao phi tập trung, và các máy trong DeepBrain Chain đã cam kết DBC, nhờ vậy đảm bảo tính ổn định của máy. Để biết thêm thông tin về DeepBrain Chain:",
    text24: 'Những lợi ích khác của việc nắm giữ Genesis Node NFT là gì?',
    details: {
      text1: "1. Việc nắm giữ một số lượng Genesis Node NFT nhất định mang lại cho bạn quyền đại lý phổ thông để bán DeepLink NFT tại một quốc gia (cần 1 NFT cho mỗi 3 triệu người tùy theo tỷ lệ dân số của quốc gia đó);",
      text2: '2. Chương trình airdrop DeepLink Coin;',
      text3: '3. Chương trình airdrop token dự án game DeepLink ươm mầm;',
      text4: '4. Quyền bầu chọn game nào sẽ được phát hành trực tuyến;',
      text5: '5. Giảm giá mua Game NFT;',
      text6: '6. Giảm giá mua quyền chơi và giờ chơi game trên đám mây;',
      text7: '7. Các quyền khác để tham gia hội đồng quản trị.'
    }
  },
  nft: {
    cont: {
      title1: 'Crown NFT',
      desc1: 'Với NFT này, bạn có 1 năm quyền truy cập vào tất cả tính năng dành cho doanh nghiệp của phần mềm DeepLink.',
      desc2: 'NFT không hoạt động sau khi mua, khi cần sử dụng, có thể kích hoạt NFT này trong phần mềm DeepLink. Khi NFT được kích hoạt',
      desc3: 'bắt đầu đếm ngược thời gian sử dụng 1 năm. 10% doanh thu NFT của phần mềm DeepLink được đầu tư vào phần thưởng node,',
      desc4: '40% số tiền thu được được đầu tư vào pool phần thưởng thanh khoản và 50% là tiền thu được của công ty điều hành DeepLink.'
    },
    enabl: {
      title1: 'Quyền NFT',
      desc1: '1 năm truy cập vào tất cả tính năng dành cho doanh nghiệp của phần mềm DeepLink',
      desc2: 'Chương trình airdrop DeepLink Coin',
      desc3: 'Chương trình airdrop token dự án game DeepLink ươm mầm',
      desc4: 'Quyền bầu chọn game nào sẽ được phát hành trực tuyến',
      desc5: 'Giảm giá mua Game NFT',
      desc6: 'Giảm giá mua quyền chơi và giờ chơi game trên đám mây',
      desc7: 'Các quyền khác để tham gia hội đồng quản trị'

    },
    edition: {
      title1: 'Phiên bản chuyên gia',
      title2: 'Phiên bản doanh nghiệp',
      tip: 'Crown NFT',
      btn: 'Mua ngay',
      title3: 'Chuyên gia VS Doanh nghiệp',
      desc: 'Truy cập các tính năng cụ thể',
      list: {
        li1_1: 'Nội dung',
        li1_2: 'Phiên bản cơ bản',
        li1_3: 'Phiên bản chuyên gia',
        li1_4: 'Phiên bản doanh nghiệp',
        li2_1: 'Chất lượng hình ảnh tốt nhất',
        li3_1: 'Chuyển tiếp phòng máy chủ server',
        li3_2: 'Số lượng nhỏ',
        li3_3: 'Số lượng lớn',
        li4_1: 'Chuyển tiếp băng thông',
        li4_2: 'Tối đa 4M',
        li4_3: 'Tối đa 20M',
        li4_4: 'Không giới hạn',
        li5_1: 'Độ trễ đầu cuối',
        li5_2: 'Tối thiểu <40ms',
        li5_3: 'Tối thiểu <20ms',
        li6_1:'Số lượng kênh',
        li7_1:'Số lượng thiết bị',
        li8_1:'Desktop từ xa',
        li9_1:'Camera từ xa',
        li10_1:'SSH từ xa',
        li11_1:'Màn hình cá nhân',
        li12_1:'Màn hình ảo',
        li13_1:'Bàn phím chơi game',
        li14_1:'Đa luồng Multi-streaming',
        li15_1:'444 Màu thật',
        li16_1:'Ghi lại ảnh chụp màn hình',
        li17_1:'Từ Màn hình kép đến Màn hình kép',
        li18_1:'Pad tay cầm, tay cầm kỹ thuật số',
        li19_1:'Quản lý Nhóm người dùng/thiết bị',
        li20_1:'SSO Đăng nhập một lần',
        li21_1:'Ủy quyền quản lý thống nhất',
        li22_1:'Triển khai hàng loạt',
        li23_1:'Kiểm tra hành vi của nhân viên',
        li24_1:'Đóng dấu mờ Watermark',
        li25_1:'Giá'
      }
    }
  }
}